<template>
  <div class="container">
    <div class="table-header">
      <h1>Postech</h1>
    </div>

    <PostechTable></PostechTable>
  </div>
</template>

<script setup lang="ts">
//import { loadingStart, loadingEnd } from '../js/common.js';
import PostechTable from './Postech-table.vue'
</script>
